export const curBookingsConstants = {
  SET_CUR_BOOKINGS: 'SET_CUR_BOOKINGS',
  INIT_CUR_BOOKINGS: 'INIT_CUR_BOOKINGS',
  UPDATE_FILE_SELECTED_AT_VIEWING_INDEX:
    'UPDATE_FILE_SELECTED_AT_VIEWING_INDEX',
  SET_VIEWING_INDEX: 'SET_VIEWING_BOOKING_INDEX',
  RESET_FILE_SELECTED_AT_VIEWING_INDEX:
    'RESET_FILE_SELECTED_AT_VIEWING_INDEX',
  UPDATE_BOOKING_NO_AT_INDEX: 'UPDATE_BOOKING_NO_AT_INDEX',
  INIT_COMMON_PAGES: 'INIT_COMMON_PAGES',
  RESET: 'RESET_CUR_BOOKINGS',
};
